<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="sec-23"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Forgiveness"><h1 class="chapter2" id="pz23-1"><a href="#/contents#ba_05" id="ab_05"><b>Forgiveness</b></a></h1>
<p id="pz23-3">To the praise of the glory of His grace, by which He made us accepted in the Beloved.</p>
<p id="pz23-4">In Him we have redemption through His blood, the forgiveness of sins, according to the riches of His grace.</p>
<p class="right" id="pz23-5"><em>Ephesians 1:6, 7</em></p>
<p id="pz23-6">You have forgiven the iniquity of Your people;</p>
<p id="pz23-7">You have covered all their sin. Selah</p>
<p class="right" id="pz23-8"><em>Psalm 85:2</em></p>
<p id="pz23-9">Therefore, if anyone is in Christ, he is a new creation; old things have passed away; behold, all things have become new.</p>
<p class="right" id="pz23-10"><em>II Corinthians 5:17</em></p>
<p id="pz23-11">As far as the east is from the west,</p>
<p id="pz23-12">So far has He removed our transgressions from us.</p>
<p class="right" id="pz23-14"><em>Psalm 103:12</em></p>
<p id="pz23-15">My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an Advocate with the Father, Jesus Christ the righteous.</p>
<p class="right" id="pz23-16"><em>1 John 2:1</em></p>
<p id="pz24-1">If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.</p>
<p class="right" id="pz24-2"><em>1 John 1:9</em></p>
<p id="pz24-3">For I will be merciful to their unrighteousness, and their sins and their lawless deeds I will remember no more.</p>
<p class="right" id="pz24-4"><em>Hebrews 8:12</em></p>
<p id="pz24-5">Let the wicked forsake his way,</p>
<p id="pz24-6">And the unrighteous man his thoughts;</p>
<p id="pz24-7">Let him return to the L<span class="smallcaps">ORD</span>,</p>
<p id="pz24-8">And He will have mercy on him;</p>
<p id="pz24-9">And to our God,</p>
<p id="pz24-10">For He will abundantly pardon.</p>
<p class="right" id="pz24-11"><em>Isaiah 55:7</em></p>
<p id="pz24-12">Bearing with one another, and forgiving one another, if anyone has a complaint against another; even as Christ forgave you, so you also must do.</p>
<p class="right" id="AMbb"><em>Colossians 3:13</em></p>
<p id="pz24-13">And whenever you stand praying, if you have anything against anyone, forgive him, that your Father in heaven may also forgive you your trespasses.</p>
<p class="right" id="pz24-14"><em>Mark 11:25</em></p>
<p id="pz25-1">And you, being dead in your trespasses and the uncircumcision of your flesh, He has made alive together with Him, having forgiven you all trespasses.</p>
<p class="right" id="An1q"><em>Colossians 2:13</em></p>
<p id="pz25-2">I will cleanse them from all their iniquity by which they have sinned against Me, and I will pardon all their iniquities by which they have sinned and by which they have transgressed against Me.</p>
<p class="right" id="AOb"><em>Jeremiah 33:8</em></p>
<p id="pz25-3">“Come now, and let us reason together,” says the L<span class="smallcaps">ORD</span>,</p>
<p id="pz25-4">“Though your sins are like scarlet,</p>
<p id="pz25-5">They shall be as white as snow;</p>
<p id="pz25-6">Though they are red like crimson,</p>
<p id="pz25-7">They shall be as wool.”</p>
<p class="right" id="pz25-8"><em>Isaiah 1:18</em></p>
<p id="pz25-9">I, even I, am He who blots out your transgressions for My own sake;</p>
<p id="pz25-10">And I will not remember your sins.</p>
<p class="right" id="pz25-11"><em>Isaiah 43:25</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter05.vue?7a406276